export const SELECT_ACCOUNTS_PREFIX = 'SELECT_ACCOUNTS_';

export const SELECT_ACCOUNTS_SORTING = SELECT_ACCOUNTS_PREFIX + 'SORTING';
export const selectAccountsSorting = (selection) => ({
  type: SELECT_ACCOUNTS_SORTING,
  selection
});

export const SELECT_ACCOUNTS_FILTERING = SELECT_ACCOUNTS_PREFIX + 'FILTERING';
export const selectAccountsFiltering = (selection) => ({
  type: SELECT_ACCOUNTS_FILTERING,
  selection
});

export const SELECT_ACCOUNTS_GROUPING = SELECT_ACCOUNTS_PREFIX + 'GROUPING';
export const selectAccountsGrouping = (selection) => ({
  type: SELECT_ACCOUNTS_GROUPING,
  selection
});
